import { signOut } from 'firebase/auth';
import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import { api } from '../services/api';
import { toast } from 'sonner';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem('firebase_id_token');
      if (token) {
        try {
          const userData = await api.auth.getMe();
          setUser(userData);
          localStorage.setItem('user_info', JSON.stringify(userData));
        } catch (error) {
          console.error('Failed to fetch user info:', error);
          // Don't logout on initial load failure, just set loading to false
        }
      }
      setLoading(false);
    };

    fetchUserInfo();
  }, []);

  const logout = async () => {
    await signOut(auth);
    localStorage.clear();
    setUser(null);
    // Reset role to admin for admin users on logout
    // This ensures they start with admin role on next login
    localStorage.setItem('active_role', 'admin');
    navigate('/');
  };

  const fetchAndStoreUserInfo = async () => {
    try {
      const userData = await api.auth.getMe();
      setUser(userData);
      localStorage.setItem('user_info', JSON.stringify(userData));
      return userData;
    } catch (error) {
      console.error('Failed to fetch user info:', error);
      toast.error('Failed to fetch user information');
      await logout();
      throw error;
    }
  };

  return (
    <AuthContext.Provider value={{ user, logout, fetchAndStoreUserInfo, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
